import LayoutContainer from 'components/Common/LayoutContainer'
import Pane from 'components/Common/Pane'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { rem } from 'polished'
import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'

const Section = styled(Pane)`
  padding: ${rem(28)} ${rem(4)};

  ${mediaQueryUp.tablet} {
    padding: ${rem(56)} 0;
  }
`

const CardsGrid = styled.div`
  display: grid;
  gap: ${rem(20)};

  ${mediaQueryUp.tablet} {
    grid-template-columns: repeat(3, 1fr);
  }
`

const Card = styled.div`
  background-color: ${props => props.theme.palette.neutral.surface.normalBackground};
  border-radius: ${props => props.theme.borderRadius.L};
  box-shadow: ${props => props.theme.shadow.bottom.medium};
  padding: ${rem(20)};
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${rem(16)};

  ${mediaQueryUp.tablet} {
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    min-height: ${rem(180)};
  }
`

const NumberCircle = styled.div`
  width: ${rem(40)};
  height: ${rem(40)};
  border-radius: 50%;
  background-color: ${props => props.theme.palette.product.loyalty.silver.darkBackground};
  color: ${props => props.theme.palette.product.loyalty.silver.darkContrast};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`

const SectionContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(24)};

  ${mediaQueryUp.tablet} {
    gap: ${rem(40)};
  }
`

function LoungePassesHowItWorksSection() {
  return <Section background="light-background">
    <LayoutContainer variant="large">
      <SectionContent>
        <Heading variant="heading2" align="center">
          <FormattedMessage
            id="KL6Akl5IOkz0fONhyIKc"
            defaultMessage="How it works"
            description="Heading for the lounge passes how-it-works section"
          />
        </Heading>
        <CardsGrid>
          <Card>
            <NumberCircle>
              <BodyText variant="large" weight="bold" colour="dark-contrast">
                <FormattedMessage
                  id="C73yrjsQnhYIbICTwGVw"
                  defaultMessage="1"
                  description="Step number 1 in the lounge passes how-it-works section"
                />
              </BodyText>
            </NumberCircle>
            <VerticalSpacer gap={4}>
              <BodyText variant="large" weight="bold">
                <FormattedMessage
                  id="zv4LqW5ig7CuAjm_z-h_"
                  defaultMessage="Book an international trip"
                  description="Title for step 1 in the lounge passes how-it-works section"
                />
              </BodyText>
              <BodyText variant="medium">
                <FormattedMessage
                  id="sNuKoXBzLbFsNwXxP_Y8"
                  defaultMessage="Select any overseas hotel, tour, cruise or flight to unlock your lounge passes."
                  description="Description for step 1 in the lounge passes how-it-works section"
                />
              </BodyText>
            </VerticalSpacer>
          </Card>
          <Card>
            <NumberCircle>
              <BodyText variant="large" weight="bold" colour="dark-contrast">
                <FormattedMessage
                  id="BZW6QuZXDaA3T-ANFp49"
                  defaultMessage="2"
                  description="Step number 2 in the lounge passes how-it-works section"
                />
              </BodyText>
            </NumberCircle>
            <VerticalSpacer gap={4}>
              <BodyText variant="large" weight="bold">
                <FormattedMessage
                  id="LpiZ33oU2ucGLSeynPQT"
                  defaultMessage="Redeem your complimentary passes"
                  description="Title for step 2 in the lounge passes how-it-works section"
                />
              </BodyText>
              <BodyText variant="medium">
                <FormattedMessage
                  id="C_YjLr_5sIyehwIYvMaV"
                  defaultMessage="Choose from eligible lounges at checkout or after booking."
                  description="Description for step 2 in the lounge passes how-it-works section"
                />
              </BodyText>
            </VerticalSpacer>
          </Card>
          <Card>
            <NumberCircle>
              <BodyText variant="large" weight="bold" colour="dark-contrast">
                <FormattedMessage
                  id="VIQdgcwmsNVVsA2HoBme"
                  defaultMessage="3"
                  description="Step number 3 in the lounge passes how-it-works section"
                />
              </BodyText>
            </NumberCircle>
            <VerticalSpacer gap={4}>
              <BodyText variant="large" weight="bold">
                <FormattedMessage
                  id="GsfYSLPDrYcVC2_e-GzC"
                  defaultMessage="Relax before your flight"
                  description="Title for step 3 in the lounge passes how-it-works section"
                />
              </BodyText>
              <BodyText variant="medium">
                <FormattedMessage
                  id="2TYWHtXw38oX1q43r34b"
                  defaultMessage="Enjoy food, drinks and a comfortable space before you fly."
                  description="Description for step 3 in the lounge passes how-it-works section"
                />
              </BodyText>
            </VerticalSpacer>
          </Card>
        </CardsGrid>
        <BodyText variant="medium" align="center">
          <FormattedMessage
            id="_8D5gHsnba6cDTj0FqF5"
            defaultMessage="<bold>Travelling with others?</bold> You can also buy additional passes for your travel companions."
            description="Footer note about buying additional lounge passes for companions"
            values={{
              bold: (chunks: React.ReactNode) => <BodyText variant="medium" weight="bold" as="span">{chunks}</BodyText>,
            }}
          />
        </BodyText>
      </SectionContent>
    </LayoutContainer>
  </Section>
}

export default LoungePassesHowItWorksSection
